module.exports = __webpack_public_path__ + "static/media/coffin-dance.4156c19b.mp3";